// extracted by mini-css-extract-plugin
export default {"checkbox-label":"nominal_checkbox-label__4TMwj","dark-background":"nominal_dark-background__EcZv+"};